import { METAVERSE_ADMIN_WALLET_ADDRESS, IS_PROD } from 'util/constants';

export const get_all_nfts_from_account_metaverse = `
import Metaverse from ${METAVERSE_ADMIN_WALLET_ADDRESS}
import NonFungibleToken from ${
  IS_PROD ? '0x1d7e57aa55817448' : '0x631e88ae7f1d7c20'
}

pub fun main(from: Address): &{UInt64: NonFungibleToken.NFT}?{
    return Metaverse.getAllNftsFromAccount(from)
}
`;
